<c-header [position]="'fixed'">
  <div class="container-fluid d-flex align-items-center justify-content-between flex-nowrap">
    <div class="d-flex align-items-center flex-nowrap">
      <img src="assets/img/brand/OVSHorizontalv1.png" width="130" alt="EKS-Ref-Arch Logo" />
      <button class="navbar-toggler px-2 me-2" type="button" (click)="toggleSidebar()" aria-label="Toggle sidebar">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>

  <!-- Left container: logo + toggler (Above)-->
  <!-- CoreUI supports placing custom controls in a 'navbar-end' div -->
  <ul class="nav header-nav ms-auto d-flex flex-row flex-nowrap align-items-center mb-0">
    <!-- Notification Bell -->
    <li class="nav-item">
      <button class="header-icon-btn"
              aria-label="Notifications"
              (click)="openAnnouncements()">
        <mat-icon
          [matBadge]="unreadCount"
          matBadgeColor="warn"
          matBadgeSize="medium">notifications</mat-icon>
        <span class="cdk-visually-hidden">
          Notifications, {{ unreadCount }} unread
        </span>
      </button>
    </li>
    <!-- Profile with popup menu -->
    <li class="nav-item ms-3">
      <button class="header-icon-btn header-avatar-btn" [matMenuTriggerFor]="profileMenu" aria-label="Profile Menu">
        <span class="header-avatar">{{ userInitial$ | async }}</span>
      </button>
    </li>
  </ul>
  </div>
</c-header>

<mat-menu #profileMenu="matMenu" class="profile-dropdown">
  <div class="profile-dropdown__header" (click)="$event.stopPropagation()">
    <span class="profile-dropdown__avatar">{{ userInitial$ | async }}</span>
    <div class="profile-dropdown__meta">
      <span class="profile-dropdown__name">{{ userName$ | async }}</span>
      <span class="profile-dropdown__role">Signed in</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="redirectToProfile()">
    <mat-icon>manage_accounts</mat-icon>
    <span>My Profile</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item
          (click)="logout()"
          *ngIf="isAuthenticated$ | async as isAuthenticated; else noAuth"
          class="profile-dropdown__logout">
    <mat-icon>logout</mat-icon>
    <span>Sign out</span>
  </button>
  <ng-template #noAuth>
    <button mat-menu-item (click)="login()">
      <mat-icon>login</mat-icon>
      <span>Login</span>
    </button>
  </ng-template>
</mat-menu>
<div class="app-body">
  <c-sidebar
    #appSidebar="cSidebar"
    class="app-sidebar"
    [position]="'fixed'"
    [narrow]="false"
    [visible]="sidebarVisible"
  >
    <c-sidebar-nav
      [navItems]="navItems"
      class="app-sidebar-nav"
      [dropdownMode]="'none'"
    ></c-sidebar-nav>
  </c-sidebar>
  <!-- Main content -->
  <main class="main">
    
  <notice-banner [notices]="notices$ | async" [dismissable]="true" [userId]="userId"></notice-banner>
    <app-info-panel>
      <div class="panel-loading" >
        <loading></loading>
        <p></p>
      </div>
      <div class="container-fluid" >
        <router-outlet></router-outlet>
      </div>
    </app-info-panel>
    <!-- /.container-fluid -->
  </main>
</div>
<c-footer>
  <span class="footer-left">&copy; {{ currentYear }} Integrationworx Ltd</span>
  <span class="footer-right ms-auto"
    >Powered by
    <a href="https://www.integrationworx.com" target="_blank"
      >Integrationworx</a
    ></span
  >
</c-footer>